import { render, staticRenderFns } from "./zhichu1.vue?vue&type=template&id=5a617562&scoped=true&"
import script from "./zhichu1.vue?vue&type=script&lang=js&"
export * from "./zhichu1.vue?vue&type=script&lang=js&"
import style0 from "./zhichu1.vue?vue&type=style&index=0&id=5a617562&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a617562",
  null
  
)

export default component.exports